'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/math-intrinsics/isNaN.js
 ** module id = 161
 ** module chunks = 0
 **/